module.exports = __webpack_public_path__ + "media/images/check_yes-05f486dc2931a0531a46697781e6faa6.svg";